import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NotificationSettings } from 'mbs-ui-shared@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationOptionsService {
  private http = inject(HttpClient);

  private readonly controllerPath = '/api/notification-options';

  get(): Observable<NotificationSettings> {
    return this.http.get<NotificationSettings>(this.controllerPath);
  }

  save(settings: NotificationSettings): Observable<NotificationSettings> {
    return this.http.put<NotificationSettings>(this.controllerPath, settings);
  }
}
